var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data.total > _vm.data.per_page
    ? _c(
        "nav",
        { staticClass: "pagination item-list-pagination" },
        [
          _c(
            "button",
            {
              staticClass: "page-item pagination-prev-nav",
              attrs: {
                disabled: !_vm.data.prev_page_url,
                "aria-label": _vm.$t("Previous"),
              },
              on: {
                click: function ($event) {
                  return _vm.selectPage(--_vm.data.current_page)
                },
              },
            },
            [
              _c("small", { attrs: { "aria-hidden": "true" } }, [_vm._v("←")]),
              _vm._v(" "),
              _c("small", [_vm._v(_vm._s(_vm.$t("Previous")))]),
            ]
          ),
          _vm._v(" "),
          _vm._l(_vm.getPages(), function (page) {
            return _c(
              "button",
              {
                staticClass: "page-item pagination-page-nav",
                class: {
                  active: page == _vm.data.current_page && page !== "…",
                  "btn-light": page !== _vm.data.current_page && page !== "…",
                },
                attrs: { disabled: page === "…" },
                on: {
                  click: function ($event) {
                    return _vm.selectPage(page)
                  },
                },
              },
              [_vm._v("\n        " + _vm._s(page) + "\n    ")]
            )
          }),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "page-item pagination-next-nav",
              attrs: {
                disabled: !_vm.data.next_page_url,
                "aria-label": _vm.$t("Next"),
              },
              on: {
                click: function ($event) {
                  return _vm.selectPage(++_vm.data.current_page)
                },
              },
            },
            [
              _c("small", [_vm._v(_vm._s(_vm.$t("Next")))]),
              _vm._v(" "),
              _c("small", { attrs: { "aria-hidden": "true" } }, [_vm._v("→")]),
            ]
          ),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }